import { ComponentProps } from "."
import Arrow from "./Arrow"
import { Box, PageLabel, Wrapper } from "./styled"

const Pagination = ({
  hasNextData,
  hasPrevData,
  link,
  next,
  page,
  prev,
  totalPages
}: ComponentProps) => {
  const shouldRenderPageLabel = Boolean(page && totalPages)

  return (
    <Wrapper>
      <Box>
        <Arrow
          cursor={prev}
          direction="prev"
          hasData={hasPrevData}
          link={link}
        />
      </Box>

      <PageLabel
        aria-hidden={!shouldRenderPageLabel}
        aria-label={shouldRenderPageLabel ? "Pagination status" : undefined}
      >
        {shouldRenderPageLabel ? `Page ${page} of ${totalPages}` : null}
      </PageLabel>

      <Box>
        <Arrow
          cursor={next}
          direction="next"
          hasData={hasNextData}
          link={link}
        />
      </Box>
    </Wrapper>
  )
}

export default Pagination
